module.exports = __webpack_public_path__ + "img/tOitJupU.e821b204.svg";